<template>
  <div class="date-tab-selector">
    <div class="tab-selector flex w-full">
      <div
        class="tab medium gray-selected flex-grow text-center"
        v-for="tab in tabs"
        :key="tab"
        :class="{ selected: isTabSelected(tab) }"
        @click="selectTab(tab)"
      >
        <span class="uppercase text-lg">{{ tab }}</span>
      </div>
    </div>
    <date-bar :date="formattedDate" @adjust-date="adjustDate" />
  </div>
</template>

<script>
import DateBar from "../components/dashboard/DateBar";
import { CalendarTypes } from "../constants/enums";

export default {
  name: "DateTabSelector",
  components: { DateBar },
  computed: {
    tabs() {
      if (this.$store.state.userType === "admin") {
        return false;
      } else {
        return [CalendarTypes.DAY, CalendarTypes.WEEK];
      }
    },
    selectedCalendarType() {
      if (this.$store.state.userType === "admin") {
        return CalendarTypes.WEEK;
      }
      return this.$store.state.selectedCalendarType;
    },
    formattedDate() {
      switch (this.selectedCalendarType) {
        case CalendarTypes.DAY:
          return this.formatDate(this.selectedDate);

        case CalendarTypes.WEEK:
          return this.formatWeek(this.selectedWeekStartDate);

        case CalendarTypes.MONTH:
          return this.formatMonth(this.selectedMonthStartDate);

        default:
          throw Error("No value exists for the given tab.");
      }
    },
    selectedDate() {
      return this.$store.state.selectedDate;
    },
    selectedWeekStartDate() {
      return this.$store.state.selectedWeekStartDate;
    },
    selectedMonthStartDate() {
      return this.$store.state.selectedMonthStartDate;
    }
  },
  methods: {
    selectTab(tab) {
      this.$store.commit("setSelectedCalendarType", tab);
    },
    isTabSelected(tab) {
      return this.selectedCalendarType === tab;
    },
    formatDate(selectedDate) {
      if (!selectedDate) {
        const date = this.$moment();
        this.$store.commit("setSelectedDate", date);
        return date.format("dddd, MMMM D");
      }
      return selectedDate.format("dddd, MMMM D");
    },
    formatWeek(selectedWeekStartDate) {
      let startOfWeek;
      if (!selectedWeekStartDate) {
        startOfWeek = this.$moment().startOf("week");
        this.$store.commit("setSelectedWeekStartDate", startOfWeek);
      } else {
        startOfWeek = selectedWeekStartDate;
      }

      const endOfWeek = startOfWeek.clone().endOf("week");

      const isSameMonth = startOfWeek.isSame(endOfWeek, "month");

      return isSameMonth
        ? `${startOfWeek.format("MMMM D")} - ${endOfWeek.format("D")}`
        : `${startOfWeek.format("MMMM D")} - ${endOfWeek.format("MMMM D")}`;
    },
    formatMonth(selectedMonthStartDate) {
      let startOfMonth;
      if (!selectedMonthStartDate) {
        startOfMonth = this.$moment().startOf("month");
        this.$store.commit("setSelectedMonthStartDate", startOfMonth);
      } else {
        startOfMonth = selectedMonthStartDate;
      }

      return startOfMonth.format("MMMM");
    },
    adjustDate(direction) {
      switch (this.selectedCalendarType) {
        case CalendarTypes.DAY:
          this.changeDay(direction);
          break;

        case CalendarTypes.WEEK:
          this.changeWeek(direction);
          break;

        case CalendarTypes.MONTH:
          this.changeMonth(direction);
          break;
      }
    },
    changeDay(direction) {
      if (direction === "forward") {
        this.$store.commit(
          "setSelectedDate",
          this.selectedDate.add(1, "day").clone()
        );
      } else {
        this.$store.commit(
          "setSelectedDate",
          this.selectedDate.subtract(1, "day").clone()
        );
      }
    },
    changeWeek(direction) {
      if (direction === "forward") {
        this.$store.commit(
          "setSelectedWeekStartDate",
          this.selectedWeekStartDate.add(1, "week").clone()
        );
      } else {
        this.$store.commit(
          "setSelectedWeekStartDate",
          this.selectedWeekStartDate.subtract(1, "week").clone()
        );
      }
    },
    changeMonth(direction) {
      if (direction === "forward") {
        this.$store.commit(
          "setSelectedMonthStartDate",
          this.selectedMonthStartDate.add(1, "month").clone()
        );
      } else {
        this.$store.commit(
          "setSelectedMonthStartDate",
          this.selectedMonthStartDate.subtract(1, "month").clone()
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.date-tab-selector {
  .tab-selector {
    .tab {
      &:nth-child(3) {
        @apply border-l-0;
      }
    }
  }
}
</style>
